export enum AXIOS_ERROR_TYPE {
    SET_REQUEST_HEADER_ERROR = "Failed to execute 'setRequestHeader' on 'XMLHttpRequest': String contains non ISO-8859-1 code point."
}